export const splitMedicalAct = (maToSplit) => {
	const splittedMa = maToSplit.split(' ')
	const [code, ...description] = splittedMa

	return {
		code,
		description: (description || []).join(' '),
	}
}

export default splitMedicalAct
